export default __webpack_public_path__ + "static/media/055-scotland.6a294c24.svg";